module.exports = __webpack_public_path__ + "img/sec4_box2.2332c46a.png";